/**
 * Google Analytics Head Script injector of the Tag Manager JavaScript code.
 * Please note that the second <noscript> code is omitted.
 * 
 * @param config Application Configuration
 */
export function googleAnalyticsHeadScripts(config) {
  if (config && config.google && config.google.gtmId && config.google.gtmId !== 'null') {
    const head = document.getElementsByTagName('head')[0];
    const googleAnalyticsScript = document.createElement('script');

    googleAnalyticsScript.innerHTML = `
    (function (w, d, s, l, i) {
      w[l] = w[l] || []; w[l].push({
        'gtm.start':
          new Date().getTime(), event: 'gtm.js'
      }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '${config.google.gtmId}');`;

    head.insertBefore(googleAnalyticsScript, head.firstChild);
  }
}